import React from 'react';
import { UnauthenticatedTemplate } from '@azure/msal-react';
import { SignInButton } from './SignInButton';

const LandingPage = () => {
    // Enhanced styles for a more professional layout
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '20px',
            paddingTop: '60px', // Added more padding to the top
        },
        card: {
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            padding: '40px',
            maxWidth: '700px', // Updated to match other pages
            width: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            margin: '0 auto', // Ensures horizontal centering
        },
        heading: {
            fontSize: '2.5rem',
            marginBottom: '20px',
            color: '#333',
            fontWeight: '600',
        },
        paragraph: {
            fontSize: '1.1rem',
            marginBottom: '30px',
            color: '#555',
            lineHeight: '1.5',
        },
        buttonContainer: {
            marginTop: '30px',
        },
        footer: {
            marginTop: '20px',
            fontSize: '0.9rem',
            color: '#6c757d',
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card} className="welcome-card">
                <h1 style={styles.heading}>Welcome</h1>
                <p style={styles.paragraph}>Please sign in to access the site.</p>
                
                <UnauthenticatedTemplate>
                    <div style={styles.buttonContainer} className="auth-button-container">
                        <SignInButton />
                    </div>
                </UnauthenticatedTemplate>
                
            </div>
        </div>
    );
};

export default LandingPage;